export const PENDING = 'Pending';
export const INFO_RECEIVED = 'Info Received';
export const IN_TRANSIT = 'In Transit';
export const OUT_FOR_DELIVERY = 'Out for Delivery';
export const FAILED_ATTEMPT = 'Failed Attempt';
export const DELIVERED = 'Delivered';
export const EXCEPTION = 'Exception';
export const EXPIRED = 'Expired';
